var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "uni-login" }, [
    _c("div", { staticClass: "login-container" }, [
      _c("img", {
        staticClass: "logo-title",
        attrs: {
          src: "https://tcr-4w06clvb-1303139375.cos.ap-beijing.myqcloud.com/gamma/images/2021-10/1635209489184_%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20211026085111.png",
          alt: "",
        },
      }),
      _vm.isShowPort == 1
        ? _c("div", { staticClass: "login-content choice-port" }, [
            _c("div", { staticClass: "port-box port-box1" }, [
              _c("div", { staticClass: "port-item" }, [
                _c("div", { staticClass: "item-title" }, [
                  _vm._v("成人高等教育入口 "),
                ]),
                _vm._m(0),
                _c(
                  "div",
                  { staticClass: "item-btn" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "btn",
                        attrs: { type: "primary", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.choicePortClick("adult")
                          },
                        },
                      },
                      [_vm._v("点击进入>>")]
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "port-item" }, [
                _c("div", { staticClass: "item-title" }, [
                  _vm._v("自学考试入口 "),
                ]),
                _vm._m(1),
                _c(
                  "div",
                  { staticClass: "item-btn" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "btn",
                        attrs: { type: "primary", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.choicePortClick("own")
                          },
                        },
                      },
                      [_vm._v("点击进入>>")]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
            _c("div", { staticClass: "port-box port-box2" }, [
              _c("div", { staticClass: "port-item" }, [
                _c("div", { staticClass: "item-title" }, [
                  _vm._v("学位申报入口 "),
                ]),
                _vm._m(2),
                _c(
                  "div",
                  { staticClass: "item-btn" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "btn",
                        attrs: { type: "primary", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.choicePortClick("academicDegree")
                          },
                        },
                      },
                      [_vm._v("点击进入>>")]
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "port-item" }, [
                _c("div", { staticClass: "item-title" }, [
                  _vm._v("毕业证明书 "),
                ]),
                _vm._m(3),
                _c(
                  "div",
                  { staticClass: "item-btn" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "btn",
                        attrs: { type: "primary", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.choicePortClick("graduationProve")
                          },
                        },
                      },
                      [_vm._v("点击进入>>")]
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "port-item" }, [
                _c("div", { staticClass: "item-title" }, [
                  _vm._v("实践考核及毕业设计（论文）报名入口"),
                ]),
                _vm._m(4),
                _c(
                  "div",
                  { staticClass: "item-btn" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "btn",
                        attrs: { type: "primary", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.choicePortClick("practicalAssessment")
                          },
                        },
                      },
                      [_vm._v("点击进入>>")]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ])
        : _vm.isShowPort == 2
        ? _c(
            "div",
            { staticClass: "login-content" },
            [
              _c(
                "div",
                {
                  staticClass: "login-content_icon",
                  on: { click: _vm.backClick },
                },
                [_c("i", { staticClass: "el-icon-arrow-left" })]
              ),
              _c("div", { staticClass: "login-content_title" }, [
                _vm._v(
                  " " + _vm._s(_vm._f("portValueFilter")(_vm.portValue)) + " "
                ),
              ]),
              _c("div", { staticClass: "wx" }),
              _c(
                "el-tabs",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isActive,
                      expression: "!isActive",
                    },
                  ],
                  staticClass: "uni-tabs",
                  model: {
                    value: _vm.activeName,
                    callback: function ($$v) {
                      _vm.activeName = $$v
                    },
                    expression: "activeName",
                  },
                },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "密码登陆", name: "first" } },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "ruleForm",
                          attrs: { model: _vm.ruleForm, rules: _vm.rules },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "uni-input-group" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "uni-label",
                                  class: {
                                    active:
                                      _vm.isLabelActive == "account" ||
                                      _vm.ruleForm.account != "",
                                  },
                                  on: { click: _vm.inputGroupClick },
                                },
                                [_vm._v("手机号/身份证")]
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "uni-input",
                                  attrs: { prop: "account" },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      clearable: "",
                                      name: "account",
                                      type: "text",
                                      autocomplete: "new-password",
                                    },
                                    on: {
                                      focus: _vm.changeLabelFocus,
                                      blur: _vm.changeLabelBlur,
                                    },
                                    model: {
                                      value: _vm.ruleForm.account,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.ruleForm,
                                          "account",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "ruleForm.account",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "uni-input-group" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "uni-label",
                                  class: {
                                    active:
                                      _vm.isLabelActive == "password" ||
                                      _vm.ruleForm.password != "",
                                  },
                                  on: { click: _vm.inputGroupClick },
                                },
                                [_vm._v("密码")]
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "uni-input",
                                  attrs: { prop: "password" },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      autocomplete: "new-password",
                                      name: "password",
                                      type: _vm.isOpen,
                                    },
                                    on: {
                                      focus: _vm.changeLabelFocus,
                                      blur: _vm.changeLabelBlur,
                                    },
                                    nativeOn: {
                                      keyup: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        )
                                          return null
                                        return _vm.refer("密码")
                                      },
                                    },
                                    model: {
                                      value: _vm.ruleForm.password,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm, "password", $$v)
                                      },
                                      expression: "ruleForm.password",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c("i", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isOpen == "password",
                                    expression: "isOpen == 'password'",
                                  },
                                ],
                                staticClass: "iconfont iconclose_eyes_",
                                on: { click: _vm.showPassword },
                              }),
                              _c("i", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isOpen == "text",
                                    expression: "isOpen == 'text'",
                                  },
                                ],
                                staticClass: "iconfont iconyanjing",
                                on: { click: _vm.showPassword },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-link",
                            {
                              staticStyle: { float: "right", color: "#5879ff" },
                              attrs: { type: "info" },
                              on: { click: _vm.handleForgetPwd },
                            },
                            [_vm._v("忘记密码 ")]
                          ),
                          _c(
                            "el-button",
                            {
                              staticClass: "refer-btn",
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.refer("密码")
                                },
                              },
                            },
                            [_vm._v("登陆 ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "验证码登陆", name: "second" } },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "codeForm",
                          attrs: { model: _vm.codeForm, rules: _vm.codeRules },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "uni-input-group" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "uni-label",
                                  class: {
                                    active:
                                      _vm.isLabelActive == "mobile" ||
                                      _vm.codeForm.mobile != "",
                                  },
                                  on: { click: _vm.inputGroupClick },
                                },
                                [_vm._v("手机号")]
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "uni-input",
                                  attrs: { prop: "mobile" },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      clearable: "",
                                      autocomplete: "off",
                                      name: "mobile",
                                    },
                                    on: {
                                      focus: _vm.changeLabelFocus,
                                      blur: _vm.changeLabelBlur,
                                    },
                                    model: {
                                      value: _vm.codeForm.mobile,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.codeForm,
                                          "mobile",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "codeForm.mobile",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "uni-input-group" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "uni-label",
                                  class: {
                                    active:
                                      _vm.isLabelActive == "code" ||
                                      _vm.codeForm.code != "",
                                  },
                                  on: { click: _vm.inputGroupClick },
                                },
                                [_vm._v("验证码")]
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "uni-input",
                                  attrs: { prop: "code" },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      autocomplete: "off",
                                      name: "code",
                                    },
                                    on: {
                                      focus: _vm.changeLabelFocus,
                                      blur: _vm.changeLabelBlur,
                                    },
                                    nativeOn: {
                                      keyup: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        )
                                          return null
                                        return _vm.refer("验证码")
                                      },
                                    },
                                    model: {
                                      value: _vm.codeForm.code,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.codeForm, "code", $$v)
                                      },
                                      expression: "codeForm.code",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-button",
                                {
                                  staticClass: "uni-code",
                                  attrs: { round: "", disabled: _vm.isTimer },
                                  on: {
                                    click: function ($event) {
                                      return _vm.getCode(60)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      !_vm.isTimer
                                        ? "获取验证码"
                                        : `(${_vm.timerCount}s) 重发`
                                    ) + " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-button",
                            {
                              staticClass: "refer-btn",
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.refer("验证码")
                                },
                              },
                            },
                            [_vm._v("登陆 ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm.isShowPort == 3
        ? _c("div", { staticClass: "login-content" }, [
            _c(
              "div",
              {
                staticClass: "login-content_icon",
                on: {
                  click: () => {
                    this.isShowPort = 2
                  },
                },
              },
              [_c("i", { staticClass: "el-icon-arrow-left" })]
            ),
            _c(
              "div",
              { staticClass: "login-content_select" },
              [
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { placeholder: "请选择班级" },
                    model: {
                      value: _vm.classCurrent,
                      callback: function ($$v) {
                        _vm.classCurrent = $$v
                      },
                      expression: "classCurrent",
                    },
                  },
                  _vm._l(_vm.classList, function (item) {
                    return _c("el-option", {
                      key: item.class_id,
                      attrs: { label: item.className, value: item.class_id },
                    })
                  }),
                  1
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "refer-btn",
                    attrs: { type: "primary" },
                    on: { click: _vm.classConfirm },
                  },
                  [_vm._v("确认班级")]
                ),
              ],
              1
            ),
          ])
        : _vm.isShowPort == 5
        ? _c("div", { staticClass: "login-content" }, [
            _c(
              "div",
              {
                staticClass: "login-content_icon",
                on: { click: _vm.backClick },
              },
              [_c("i", { staticClass: "el-icon-arrow-left" })]
            ),
            _c("div", { staticClass: "login-content_title" }, [
              _vm._v(
                " " + _vm._s(_vm._f("portValueFilter")(_vm.portValue)) + " "
              ),
            ]),
            _c("div", { staticClass: "wx" }),
            _c(
              "div",
              { staticClass: "uni-tabs" },
              [
                _c(
                  "el-form",
                  {
                    ref: "practicalAssessmentRuleForm",
                    attrs: {
                      model: _vm.practicalAssessmentRuleForm,
                      rules: _vm.practicalAssessmentRules,
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "uni-input-group" },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "uni-label",
                            class: {
                              active:
                                _vm.isLabelActive == "identity" ||
                                _vm.practicalAssessmentRuleForm.identity != "",
                            },
                            on: { click: _vm.inputGroupClick },
                          },
                          [_vm._v("身份证")]
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "uni-input",
                            attrs: { prop: "identity" },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                clearable: "",
                                name: "identity",
                                type: "text",
                                autocomplete: "new-password",
                              },
                              on: {
                                focus: _vm.changeLabelFocus,
                                blur: _vm.changeLabelBlur,
                              },
                              model: {
                                value: _vm.practicalAssessmentRuleForm.identity,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.practicalAssessmentRuleForm,
                                    "identity",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression:
                                  "practicalAssessmentRuleForm.identity",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "uni-input-group" },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "uni-label",
                            class: {
                              active:
                                _vm.isLabelActive == "exam_number" ||
                                _vm.practicalAssessmentRuleForm.exam_number !=
                                  "",
                            },
                            on: { click: _vm.inputGroupClick },
                          },
                          [_vm._v("准考证号")]
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "uni-input",
                            attrs: { prop: "exam_number" },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                clearable: "",
                                name: "exam_number",
                                type: "text",
                                autocomplete: "new-password",
                              },
                              on: {
                                focus: _vm.changeLabelFocus,
                                blur: _vm.changeLabelBlur,
                              },
                              model: {
                                value:
                                  _vm.practicalAssessmentRuleForm.exam_number,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.practicalAssessmentRuleForm,
                                    "exam_number",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression:
                                  "practicalAssessmentRuleForm.exam_number",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "uni-input-group" },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "uni-label",
                            class: {
                              active:
                                _vm.isLabelActive == "student_title" ||
                                _vm.practicalAssessmentRuleForm.student_title !=
                                  "",
                            },
                            on: { click: _vm.inputGroupClick },
                          },
                          [_vm._v("学生姓名")]
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "uni-input",
                            attrs: { prop: "student_title" },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                clearable: "",
                                name: "student_title",
                                type: "text",
                                autocomplete: "new-password",
                              },
                              on: {
                                focus: _vm.changeLabelFocus,
                                blur: _vm.changeLabelBlur,
                              },
                              model: {
                                value:
                                  _vm.practicalAssessmentRuleForm.student_title,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.practicalAssessmentRuleForm,
                                    "student_title",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression:
                                  "practicalAssessmentRuleForm.student_title",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "uni-input-group" },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "uni-label",
                            class: {
                              active:
                                _vm.isLabelActive == "phone" ||
                                _vm.practicalAssessmentRuleForm.phone != "",
                            },
                            on: { click: _vm.inputGroupClick },
                          },
                          [_vm._v("手机号")]
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "uni-input",
                            attrs: { prop: "phone" },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                clearable: "",
                                autocomplete: "off",
                                name: "phone",
                              },
                              on: {
                                focus: _vm.changeLabelFocus,
                                blur: _vm.changeLabelBlur,
                              },
                              model: {
                                value: _vm.practicalAssessmentRuleForm.phone,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.practicalAssessmentRuleForm,
                                    "phone",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "practicalAssessmentRuleForm.phone",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "refer-btn",
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.refer("practicalAssessment")
                          },
                        },
                      },
                      [_vm._v("登陆 ")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c("img", {
        staticClass: "unit-bootom-img",
        attrs: { src: require("@/assets/images/login_bg2.png"), alt: "" },
      }),
    ]),
    _c("p", { staticClass: "ori-footerUrl" }, [
      _c("i"),
      _c(
        "span",
        {
          on: {
            click: function ($event) {
              return _vm.isUrl(3)
            },
          },
        },
        [_vm._v("渝公网安备 50010602502220 号")]
      ),
      _vm._v("， 技术支持："),
      _c(
        "span",
        {
          on: {
            click: function ($event) {
              return _vm.isUrl(1)
            },
          },
        },
        [_vm._v("重庆卓培教育科技有限公司")]
      ),
      _vm._v("，"),
      _c(
        "span",
        {
          on: {
            click: function ($event) {
              return _vm.isUrl(2)
            },
          },
        },
        [_vm._v("渝ICP备18010001号-6")]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "item-img" }, [
      _c("img", {
        staticClass: "img",
        attrs: {
          src: require("../../assets/images/choice_port1.png"),
          alt: "",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "item-img" }, [
      _c("img", {
        staticClass: "img",
        attrs: {
          src: require("../../assets/images/choice_port2.png"),
          alt: "",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "item-img" }, [
      _c("img", {
        staticClass: "img",
        attrs: {
          src: require("../../assets/images/choice_port2.png"),
          alt: "",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "item-img" }, [
      _c("img", {
        staticClass: "img",
        attrs: {
          src: require("../../assets/images/choice_port2.png"),
          alt: "",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "item-img" }, [
      _c("img", {
        staticClass: "img",
        attrs: {
          src: require("../../assets/images/choice_port2.png"),
          alt: "",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }